<template>
  <div class="flex-page">
    <a-form class="ctrl" layout="inline">
      <a-form-item label="昵称">
        <a-input style="width: 200px" placeholder="请输入微信昵称" v-model="options.nickName"></a-input>
      </a-form-item>
      <a-form-item label="交易单号">
        <a-input style="width: 200px" placeholder="请输入微信交易单号" v-model="options.transaction_id"></a-input>
      </a-form-item>
      <a-form-item label="退票原因">
        <a-input style="width: 200px" placeholder="请输入微信交易单号" v-model="options.tuipiaoDesc"></a-input>
      </a-form-item>
      <a-form-item label="状态">
        <a-select style="width: 200px" v-model="options.zhuangtai" @change="search">
          <a-select-option :value="0">全部</a-select-option>
          <a-select-option :value="1">微信支付</a-select-option>
          <a-select-option :value="2">后台赠送</a-select-option>
          <a-select-option :value="3">已退票</a-select-option>
          <a-select-option :value="4">已退款</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item>
        <a-button type="primary" @click="search">搜索</a-button>
      </a-form-item>
    </a-form>

    <div class="statistics">共{{ page.amount }}个，共{{ sumMoney }}元</div>

    <a-table class="main" size="small" :rowKey="(record) => record.id" bordered :columns="columns" :data-source="list"
      :pagination="false">
      <template slot="weixin" slot-scope="text, record">
        <div style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
          <img :src="record.headImgUrl" style="width: 30px;" alt="">
        </div>
      </template>
      <template slot="transaction_id" slot-scope="text, record">
        <div v-if="record.zengsong == 1">后台赠送</div>
        <div v-else>{{ record.transaction_id || '' }}</div>
      </template>

      <template slot="zhuangtai" slot-scope="text, record">
        <a-tag v-if="record.status == 1" color="green">正常</a-tag>
        <a-tag v-if="record.status == -1" color="orange">已退票</a-tag>
        <a-tag v-if="record.status == -2" color="red">已退款</a-tag>
      </template>
      <template slot="action" slot-scope="text, record">
        <a v-if="record.status == 1" href="javascript:;" @click="showTuipiao(record.id)" style="color: orange;">退票</a>
        <a-popconfirm v-if="record.status == -1" title="确定退款吗？" ok-text="确定" cancel-text="取消"
          @confirm="doStatus(record.id, -2)">
          <a href="javascript:;" style="color: red;">退款</a>
        </a-popconfirm>
      </template>
    </a-table>

    <a-pagination class="pagination" showQuickJumper v-model="page.now_page" :defaultPageSize="page.page_size"
      :total="page.amount" @change="changePage" />
    <Tuipiao v-if="tuipiao.show" :id="tuipiao.id" @modelCallBack="tuipiaoCallBack" />
  </div>
</template>

<style lang='scss' scoped></style>

<script>
import Tuipiao from './component/tuipiao.vue';
const columns = [
  {
    title: "序号",
    dataIndex: "id",
  },
  {
    title: "微信头像",
    scopedSlots: { customRender: "weixin" },
  },
  {
    title: "微信昵称",
    dataIndex: "nickName",
  },
  {
    title: "门票",
    dataIndex: "menpaio_title",
  },
  {
    title: "金额",
    dataIndex: "money",
  },
  {
    title: "购票时间",
    dataIndex: "create_time",
  },
  {
    title: "微信交易单号",
    scopedSlots: { customRender: "transaction_id" },
  },
  {
    title: "退票原因",
    dataIndex: "tuipiaoDesc"
  },
  {
    title: "退票时间",
    dataIndex: "tuipiaoTime",
  },
  {
    title: "退款时间",
    dataIndex: "tuikuanTime",
  },
  {
    title: "状态",
    scopedSlots: { customRender: "zhuangtai" },
  },
  {
    title: "操作",
    scopedSlots: {
      customRender: "action",
    },
  },
];

export default {
  components: { Tuipiao },
  data() {
    return {
      columns,
      list: [],
      options: {
        nickName: "",
        transaction_id: '',
        zhuangtai: 0,
        tuipiaoDesc: ''
      },
      page: {
        now_page: 1,
        page_size: 50,
        amount: 0,
      },
      sumMoney: 0,
      groupList: [],
      menpiao_id: null,
      tuipiao: {
        show: false,
        id: null
      }
    };
  },
  created() {
    this.menpiao_id = this.$route.query.id
    this.getList();
  },
  methods: {

    search() {
      this.page.now_page = 1;
      this.getList();
    },
    changePage(e) {
      this.page.now_page = e;
      this.getList();
    },

    async getList() {
      const options = { ...this.options };
      options.page = this.page.now_page;
      options.menpiao_id = this.menpiao_id
      const r = await this.$axios.post("/exh/menpiao/tongji", options);
      this.list = r.list;
      this.page.amount = r.amount;
      this.sumMoney = r.sumMoney
    },
    async doStatus(id, status) {
      const r = await this.$axios.post("/exh/menpiao/updateMenpiaoRecordStatus", {
        id: id,
        status: status,
      });
      if (r.status == 1) {
        // this.$message.success("操作成功");
        this.getList();
      } else {
        this.$message.error("操作失败");
      }
    },

    showTuipiao(id) {
      this.tuipiao.show = true
      this.tuipiao.id = id
    },
    tuipiaoCallBack(e) {
      if (e.status == 1) {
        this.getList();
      }
      this.tuipiao.show = false
      this.tuipiao.id = null
    }
  },
};
</script>